import { DEFINITIONS as LINK_DEFINITIONS } from '@xing-com/content-editor-plugin-link';
import { DEFINITIONS as LIST_ITEM_PLUGIN_DEFINITIONS } from '@xing-com/content-editor-plugin-list-item';
import { DEFINITIONS as MENTION_DEFINITIONS } from '@xing-com/content-editor-plugin-mention';
// eslint-disable-next-line max-len

export const SERIALIZATION = 'serialization';
export const DESERIALIZATION = 'deserialization';
export const BLOCK_OBJECT = 'block'; // is not needed anymore
export const MARK_OBJECT = 'mark';
export const INLINE_OBJECT = 'inline';

// GRAPHQL TypeNames
export const COVER_IMAGE_TYPENAME = 'ArticleCoverImage';
export const BOLD_TYPENAME = 'ArticleBoldMarkup';
export const EMPHASIS_TYPENAME = 'ArticleEmphasis';
export const HEADING2_TYPENAME = 'ArticleH2';
export const HEADING3_TYPENAME = 'ArticleH3';
export const HEADING4_TYPENAME = 'ArticleH4';
export const ITALIC_TYPENAME = 'ArticleItalicMarkup';
export const LINK_TYPENAME = 'ArticleLinkMarkup';
export const MENTION_TYPENAME = 'ArticleMentionMarkup';
export const ORDERED_LIST_ITEM_TYPENAME = 'ArticleOrderedListItem';
export const PARAGRAPH_TYPENAME = 'ArticleParagraph';
export const QUOTE_TYPENAME = 'ArticleQuote';
export const SUMMARY_TYPENAME = 'ArticleSummary';
export const TITLE_TYPENAME = 'ArticleTitle';
export const UNORDERED_LIST_ITEM_TYPENAME = 'ArticleUnorderedListItem';
export const IMAGE_TYPENAME = 'ArticleBodyImage';
export const BODY_IMAGE_PARAM_TYPE_UUID = 'IMAGE_CACHE_UUID';
export const BODY_IMAGE_PARAM_TYPE_UPLOAD_ID = 'UPLOAD_ID';

// GRAPHQL fieldNames
export const COVER_IMAGE_FIELDNAME = 'cover';
export const EMPHASIS_FIELDNAME = 'articleEmphasis';
export const HEADING2_FIELDNAME = 'articleH2';
export const HEADING3_FIELDNAME = 'articleH3';
export const HEADING4_FIELDNAME = 'articleH4';
export const ORDERED_LIST_ITEM_FIELDNAME = 'articleOrderedListItem';
export const PARAGRAPH_FIELDNAME = 'articleParagraph';
export const QUOTE_FIELDNAME = 'articleQuote';
export const SUMMARY_FIELDENAME = 'summary';
export const TITLE_FIELDENAME = 'title';
export const UNORDERED_LIST_ITEM_FIELDNAME = 'articleUnorderedListItem';
export const IMAGE_FIELDNAME = 'articleBodyImage';

export const BLOCK_TYPENAMES = [
  HEADING2_TYPENAME,
  HEADING3_TYPENAME,
  HEADING4_TYPENAME,
  ORDERED_LIST_ITEM_TYPENAME,
  PARAGRAPH_TYPENAME,
  SUMMARY_TYPENAME,
  TITLE_TYPENAME,
  UNORDERED_LIST_ITEM_TYPENAME,
];

export const TEXT_OBJECT = 'text';
export const TEXT_TYPENAME = 'ArticleText';

export const INLINE_TYPES = [LINK_DEFINITIONS.type, MENTION_DEFINITIONS.type];

export const INPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS = {
  ...LIST_ITEM_PLUGIN_DEFINITIONS, // type: list-item
  __typename: ORDERED_LIST_ITEM_FIELDNAME,
};
export const INPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS = {
  ...LIST_ITEM_PLUGIN_DEFINITIONS,
  __typename: UNORDERED_LIST_ITEM_FIELDNAME,
};
export const OUTPUT_DEFINITIONS_FOR_ORDERED_LIST_ITEMS = {
  ...LIST_ITEM_PLUGIN_DEFINITIONS,
  __typename: ORDERED_LIST_ITEM_TYPENAME,
};
export const OUTPUT_DEFINITIONS_FOR_UNORDERED_LIST_ITEMS = {
  ...LIST_ITEM_PLUGIN_DEFINITIONS,
  __typename: UNORDERED_LIST_ITEM_TYPENAME,
};
